export const RUFFLE_ORIGIN = "https://ruffle.rs";
